export class RPCMethods {
    public get getAccounts(): string {
        return "eth_accounts";
    }

    public get requestAccounts(): string {
        return "eth_requestAccounts";
    }

    public get getChainId(): string {
        return "eth_chainId";
    }

    public get addChain(): string {
        return "wallet_addEthereumChain";
    }

    public get switchChain(): string {
        return "wallet_switchEthereumChain";
    }

    public get signMessage(): string {
        return "personal_sign";
    }

    public get sendTransaction(): string {
        return "eth_sendTransaction";
    }

    public get revokePermissions(): string {
        return "wallet_revokePermissions";
    }
}